import { Grid, Typography } from '@material-ui/core';
import { BotType } from 'api-clients/monolith';
import React, { VFC } from 'react';

import { useStyles } from './styles';

export interface TopLabelsProps {
  botType: BotType;
}

export const TopLabels: VFC<TopLabelsProps> = ({ botType }) => {
  const styles = useStyles();

  return (
    <Grid
      item
      container
      direction="row"
      spacing={1}
      className={styles.labelsWrapper}
    >
      <Grid item>
        <Typography variant="body2" className={styles.label}>
          {botType}
        </Typography>
      </Grid>
    </Grid>
  );
};
